export default __webpack_public_path__ + "static/media/BCA13.ffee8000.jpg";